import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { makeAxiosGetRequest, makeAxiosPostRequest } from '../utils/utils';

type AxiosGetCallbackReturn<T = any> = [T | null, boolean, string, (url: string) => void];
export const useAxiosGetCallback = <T extends any>(): AxiosGetCallbackReturn<T> => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);

  const makeRequest = useCallback((url: string) => {
    makeAxiosGetRequest(url, setData, setLoading, setErr);
  }, []);

  return [data, loading, err, makeRequest];
};

export const useAxiosGet = (url: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);

  useEffect(() => {
    makeAxiosGetRequest(url, setData, setLoading, setErr);
  }, [url]);

  const reload = () => makeAxiosGetRequest(url, setData, setLoading, setErr);

  return [data, loading, err, reload];
};

export const useAxiosPostCallback = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);

  const makeRequest = useCallback((url: string, data?: any) => {
    makeAxiosPostRequest(url, data, setData, setLoading, setErr);
  }, []);

  return [data, loading, err, makeRequest];
};

export const useAxiosDeleteCallback = () => {
  const [res, setRes] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);

  const makeRequest = useCallback((url: string, id: string) => {
    setLoading(true);
    axios
      .delete(url + id)
      .then(res => setRes(res))
      .catch(err => {
        if (err) setErr(String(err));
      })
      .finally(() => {
        setLoading(false);
        setErr(null);
      });
  }, []);
  return [res, loading, err, makeRequest];
};
